/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusIndividuelleAnforderungStandortDto } from '../../models/lexplus-individuelle-anforderung-standort-dto';
import { LexplusUpdateAnforderungErfuellungsgradDto } from '../../models/lexplus-update-anforderung-erfuellungsgrad-dto';

export interface IndividuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradV1$Params {
  individuelleAnforderungID: string;
  standortID: number;
      body: LexplusUpdateAnforderungErfuellungsgradDto
}

export function individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusIndividuelleAnforderungStandortDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradV1.PATH, 'patch');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.path('standortID', params.standortID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusIndividuelleAnforderungStandortDto>;
    })
  );
}

individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungErfuellungsgradV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}/standorte/{standortID}/erfuellungsgrad';
